/*
 * Ordnova Motion – GSAP + ScrollTrigger + SplitText + Lenis
 * Effekte im Stil von React Bits (Split-Text, Scroll-Reveal, Magnet-Buttons, Spotlight-Karten),
 * in Vanilla-JS nachgebaut, damit sie im Shopify-Theme ohne React laufen.
 * Bei "Bewegung reduzieren" (Systemeinstellung) wird nichts animiert.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  function ready() { root.classList.add('ord-motion-ready'); }
  function bail() { root.classList.remove('ord-motion'); ready(); }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !window.gsap || !window.ScrollTrigger) { bail(); return; }

  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var Split = window.SplitText || null;
  gsap.registerPlugin(ST);
  if (Split) gsap.registerPlugin(Split);

  var EASE = 'power3.out';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- 1. Lenis: weiches Scrollen ---------- */
  var lenis = null;
  if (window.Lenis) {
    lenis = new window.Lenis({
      lerp: 0.16,
      smoothWheel: true,
      syncTouch: false,
      anchors: { offset: -90 },
      prevent: function (node) {
        return !!(node && node.closest && node.closest(
          'dialog, [role="dialog"], [data-lenis-prevent], .cart-drawer, .menu-drawer, .search-modal, .quick-add-modal, .chat-drawer, .o-vid__list'
        ));
      }
    });
    window.ordLenis = lenis;
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);

    // Lenis anhalten, solange Warenkorb, Menü oder ein Popup offen ist
    var queued = false;
    var syncLock = function () {
      queued = false;
      var bodyOverflow = getComputedStyle(document.body).overflowY;
      var locked = !!document.querySelector('dialog[open]') ||
        bodyOverflow === 'hidden' || bodyOverflow === 'clip' ||
        root.style.overflow === 'hidden' || root.hasAttribute('scroll-lock');
      if (locked) lenis.stop(); else lenis.start();
    };
    var schedule = function () { if (!queued) { queued = true; requestAnimationFrame(syncLock); } };
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['style', 'scroll-lock'] });
    new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }

  /* ---------- 2. Scroll-Fortschritt (dünne grüne Linie oben) ---------- */
  var bar = document.createElement('div');
  bar.className = 'ord-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { start: 0, end: 'max', scrub: 0.3 } });

  /* Hilfsfunktion: Überschrift in Wörter teilen (wie React Bits "SplitText") */
  function splitWords(el) {
    if (!Split || !el || el.getAttribute('data-ord-split')) return null;
    el.setAttribute('data-ord-split', '1');
    try { return Split.create(el, { type: 'words', mask: 'words', wordsClass: 'ord-w' }); }
    catch (e) { return null; }
  }

  /* ---------- 3. Hauptbanner: Intro ---------- */
  var hero = $('.o-hero');
  if (hero) {
    var box = $('.o-hero__box', hero);
    var title = $('.o-hero__title', hero);
    var img = $('.o-hero__img', hero);
    if (box) gsap.set(box, { visibility: 'visible' });
    var tl = gsap.timeline({ defaults: { ease: EASE } });
    if (img) tl.fromTo(img, { scale: 1.06 }, { scale: 1, duration: 1.4, ease: 'power2.out', clearProps: 'transform' }, 0);
    var hs = splitWords(title);
    if (hs) tl.from(hs.words, { yPercent: 115, duration: 1, stagger: 0.07 }, 0.1);
    else if (title) tl.from(title, { y: 30, autoAlpha: 0, duration: 0.9 }, 0.1);
    var rest = $$('.o-hero__text, .o-hero__btns', hero);
    if (rest.length) tl.from(rest, { y: 22, autoAlpha: 0, duration: 0.8, stagger: 0.12 }, 0.5);
  }
  ready();

  /* ---------- 4. Überschriften: Wort für Wort beim Scrollen ---------- */
  $$('.o-h2, .o-news__h').forEach(function (h) {
    if (h.closest('.o-hero')) return;
    var sp = splitWords(h);
    var st = { trigger: h, start: 'top 88%', end: 'max', once: true };
    if (sp) gsap.from(sp.words, { yPercent: 110, duration: 0.9, ease: EASE, stagger: 0.045, scrollTrigger: st });
    else gsap.from(h, { y: 24, autoAlpha: 0, duration: 0.8, ease: EASE, scrollTrigger: st });
  });

  /* ---------- 5. Karten und Blöcke: gestaffelt einblenden ---------- */
  var revealSel = [
    '.o-trust__item', '.o-cat', '.o-card', '.o-sol__col', '.o-vid__item', '.o-rev', '.o-acc',
    '.o-brand__body', '.o-head .o-eyebrow', '.o-head .o-sub', '.o-head .o-link',
    '.o-prod__more', '.o-faq__head .o-sub', '.o-faq__mail', '.o-news__t', '.o-news__form'
  ].join(',');
  var items = $$(revealSel).filter(function (el) {
    if (el.closest('.o-hero')) return false;
    // Was beim Laden schon oberhalb des Bildschirms liegt, bleibt einfach sichtbar
    return el.getBoundingClientRect().bottom > 0;
  });
  if (items.length) {
    gsap.set(items, { autoAlpha: 0, y: 34 });
    ST.batch(items, {
      start: 'top 92%',
      end: 'max',
      once: true,
      interval: 0.1,
      batchMax: 6,
      onEnter: function (batch) {
        gsap.to(batch, { autoAlpha: 1, y: 0, duration: 0.85, ease: EASE, stagger: 0.08, overwrite: 'auto', clearProps: 'transform' });
      }
    });
  }

  /* ---------- 6. Markenbild: aufziehen ---------- */
  var bm = $('.o-brand__media');
  if (bm) {
    gsap.fromTo(bm,
      { clipPath: 'inset(10% 10% 10% 10% round 20px)' },
      { clipPath: 'inset(0% 0% 0% 0% round 20px)', duration: 1.1, ease: 'power3.inOut', clearProps: 'clipPath',
        scrollTrigger: { trigger: bm, start: 'top 85%', end: 'max', once: true } });
  }

  /* ---------- 7. Nur Desktop mit Maus: Magnet-Buttons, Spotlight ---------- */
  var mm = gsap.matchMedia();
  mm.add('(min-width: 990px) and (hover: hover) and (pointer: fine)', function () {
    var cleanups = [];

    // Magnet-Buttons (wie React Bits "Magnet")
    $$('.o-btn').forEach(function (btn) {
      var xTo = gsap.quickTo(btn, 'x', { duration: 0.45, ease: 'power3' });
      var yTo = gsap.quickTo(btn, 'y', { duration: 0.45, ease: 'power3' });
      var move = function (e) {
        var r = btn.getBoundingClientRect();
        xTo((e.clientX - r.left - r.width / 2) * 0.22);
        yTo((e.clientY - r.top - r.height / 2) * 0.3);
      };
      var leave = function () { xTo(0); yTo(0); };
      btn.addEventListener('pointermove', move);
      btn.addEventListener('pointerleave', leave);
      cleanups.push(function () {
        btn.removeEventListener('pointermove', move);
        btn.removeEventListener('pointerleave', leave);
        gsap.set(btn, { clearProps: 'x,y' });
      });
    });

    // Spotlight auf Karten (wie React Bits "SpotlightCard")
    $$('.o-cat__link, .o-card, .o-sol__col').forEach(function (el) {
      var mv = function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top) + 'px');
      };
      el.addEventListener('pointermove', mv);
      cleanups.push(function () { el.removeEventListener('pointermove', mv); });
    });

    return function () { cleanups.forEach(function (f) { f(); }); };
  });

  /* ---------- 8. Positionen neu berechnen, wenn Bilder und Schriften geladen sind ---------- */
  window.addEventListener('load', function () { ST.refresh(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ST.refresh(); });
})();
